import script from "./PortfolioActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioActions.vue?vue&type=script&setup=true&lang=ts"

import "./PortfolioActions.vue?vue&type=style&index=0&id=bbafcbb8&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbafcbb8"]])

export default __exports__